import { useContext } from 'react';
import IndustriesContext from 'src/contexts/IndustriesContext';

const useIndustriesContext = () => {
  const context = useContext(IndustriesContext);
  if (!context) {
    throw new Error(
      'useIndustriesContext must be used within a IndustriesContextProvider'
    );
  }
  return context;
};

export default useIndustriesContext;
